import { render, staticRenderFns } from "./EfspTable.vue?vue&type=template&id=72811dcf"
import script from "./EfspTable.vue?vue&type=script&lang=ts"
export * from "./EfspTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports